import { render } from "./RequisitionsModal.vue?vue&type=template&id=5e285740"
import script from "./RequisitionsModal.vue?vue&type=script&lang=js"
export * from "./RequisitionsModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__